import { render } from "./MyInput.vue?vue&type=template&id=b3e2c42c"
import script from "./MyInput.vue?vue&type=script&lang=js"
export * from "./MyInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__